// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-logo-ut{fill:var(--main)}.icon-logo-ut--light{fill:var(--contrast)}@keyframes preloader-ut{0%{stroke-dasharray:0 98}50%{stroke-dasharray:98 0}100%{stroke-dasharray:98 98}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
